import axios from "axios";
import {
    ESApiFinalResponseInterface,
    ESApiResponseInterface,
} from "../interfaces/ElasticSearchInterface";
import { EnvironmentConfig } from "@me8eon/config";
import { JwtTokenFn } from "@me8eon/authentication";

export const getSearchResultsForProd = async (
    searchTerm: string,
    esApiKey: JwtTokenFn,
    neighbourCount?: number,
    indexToSearch?: string,
): Promise<ESApiFinalResponseInterface[]> => {
    const searchIndex = indexToSearch ?? EnvironmentConfig.appIndex;
    const k = neighbourCount ?? 3;
    const apiKey = await esApiKey();

    const ELASTICSEARCH_URL = `${EnvironmentConfig.elasticSearchProxyUrl}/${searchIndex}/_search`;
    try {
        const response = await axios.post(
            ELASTICSEARCH_URL,
            {
                _source: {
                    excludes: [
                        "full_text_embeddings",
                        "full_text",
                        "file",
                        "pdf file path",
                        "pdf",
                    ],
                },
                knn: {
                    // nearest neighbour
                    field: "full_text_embeddings",
                    query_vector_builder: {
                        text_embedding: {
                            model_id: ".multilingual-e5-small_linux-x86_64",
                            model_text: searchTerm,
                        },
                    },
                    k, // two nearest nbr
                    num_candidates: k * 5, // total 5
                },
                size: k
            },
            {
                headers: {
                    Authorization:
                        `Bearer ${apiKey}`,
                },
            }
        );
        const suggestions: ESApiFinalResponseInterface[] =
            response.data.hits.hits.map(
                (hit: ESApiResponseInterface) => {
                    return {
                        ...hit._source,
                        highlight: hit.highlight,
                        index: hit._index,
                        score: hit._score,
                    };
                } // Replace your_field_name with the field you want to autocomplete
            );
        return suggestions;
    } catch (error) {
        console.error("Error fetching autocomplete suggestions:", error);
        return [];
    }
};
